import React from "react";
import * as dc from "dc";
import { ChartTemplate } from "../chartTemplate";
import * as d3 from "d3";
import { Wrapper } from "../../helper/warpLabels";

/* 
dc-js chart template 
 */

const cropChartFunc = (divRef, ndx) => {
    const dim_area = ndx.dimension((d) => d.crop_Area_Ha)
    function rotate(dim, cols) {
        var _groupAll = dim.groupAll().reduce(
            function (p, v) {
                // add
                cols.forEach(function (c) {
                    p[c] += v[c];
                });
                return p;
            },
            function (p, v) {
                // remove
                cols.forEach(function (c) {
                    p[c] -= v[c];
                });
                return p;
            },
            function () {
                // init
                var p = {};
                cols.forEach(function (c) {
                    p[c] = 0;
                });
                return p;
            }
        );
        return {
            all: function () {
                return d3.map(_groupAll.value()).entries();
            },
        };
    }

    const dim_area_grp = rotate(dim_area, [
        "crop_Area_Ha",
        "crop_Quality_Tones",
    ]);

   
    let f = d3.format(",.2f") // format  lables
    const composite = dc.barChart(divRef);
    composite
        .width(230)
        .height(200)
        .dimension(dim_area)
        .group(dim_area_grp)
        .x(d3.scaleBand())
        .xUnits(dc.units.ordinal)
        .brushOn(false)
        .barPadding(0.1)
        .outerPadding(0.05)
        .colorAccessor((d) => d.key)
        .ordinalColors(["#B5870D", "#8AB3C9"])
        .valueAccessor((d) => {
            if (d.value == 0) {
                return d.value
            } else {
                return Math.log10(d.value)
            }

        })
        .title((d) => {
            if (d.key == "crop_Area_Ha") {
                return "Crop Area (Ha)" + ` : ${f(d.value)}`
            } else {
                return "Quantity (Tonnes)" + ` : ${f(d.value)}`
            }

        })
       

    composite.yAxis().ticks(0);
    composite.xAxis().tickFormat(function (v) {
        if (v == "crop_Area_Ha") {
            return "Area (Ha)";
        } else if (v == "crop_Quality_Tones") {
            return "Quantity (Tonnes)";
        }
    });
    return composite;
};
export const CropStatChart = (props) => (
  //  pass the chart object as a prop to the chart  function
  <ChartTemplate chartFunction={cropChartFunc} />
);
